/* eslint-disable unused-imports/no-unused-imports */
import React from "react"
import MobileSort from "../../../mobileSort"
import ShowFilters from "../../../showFilters"
import connect from "../../connect"
import {MobileHeader} from "./components"

export interface MobileHeaderProps {
    sticky: boolean
    inPageFiltersVisible: boolean
}

const StandardMobileHeader = ({sticky, inPageFiltersVisible}: MobileHeaderProps) => {
    return (
        <MobileHeader sticky={sticky} data-scrollanchor={inPageFiltersVisible}>
            <MobileSort />
            <ShowFilters />
        </MobileHeader>
    )
}

export default connect(StandardMobileHeader)
